import { MoreHorizontal } from 'lucide-react'
import { Button } from '../ui/Button.js'
import { DropdownMenu, type MenuItem } from '../ui/DropdownMenu.js'

/**
 * The ⋯ on a row, everywhere there is one.
 *
 * *"how can you use a different three dot menu here and differnet in all
 * other places like members providers etc"* — because there were two. The
 * tables drew a `MoreHorizontal` in a ghost square, and the editable lists in
 * Settings drew a literal `⋮` character in a different square, so the same
 * control looked like two controls depending on which tab you were on.
 *
 * One component, so there is one of them. `DataTable`, `EditableList` and
 * anything else that grows a row menu use this rather than assembling a
 * trigger of their own — which is how the second one appeared.
 *
 * The negative margin is the kit's own rule, in as many words:
 *
 * ```css
 * .fawn-table td button { padding: 6px 0; margin: -6px 0; }
 * ```
 *
 * A control in a cell padded 12px made every row taller than it should be.
 * The margin gives the height back.
 *
 * `stopPropagation` on the wrapper as well as the trigger, because the row
 * itself is usually clickable and a menu that also opens the record behind it
 * is a menu nobody trusts.
 */
export function RowMenu({
  items,
  label = 'What you can do with this',
}: {
  items: MenuItem[]
  label?: string
}) {
  if (items.length === 0) return null
  return (
    <div className="-my-2 flex justify-end" onClick={(e) => e.stopPropagation()}>
      <DropdownMenu
        items={items}
        trigger={
          <Button variant="ghost" size="icon-sm" aria-label={label}>
            <MoreHorizontal />
          </Button>
        }
      />
    </div>
  )
}
